<template>
  <div>
    <el-form-item label="Vide intérieur" >
      <el-slider v-model="inner" @change="handleChange" :min="0" :max="100" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    }
  },
  data () {
    return {
      inner: 75
    }
  },
  watch:
  {
    value: {
      handler (value) {
        try {
          const data = JSON.parse(value)
          if (typeof data === 'object') {
            this.inner = typeof data.inner !== 'undefined' ? data.inner : 75
          }
        }
        catch (error) {
          this.setDefaultValues()
        }
      },
      immediate: true
    }
  },
  methods: {
    setDefaultValues () {
      this.inner = 75
    },
    handleChange () {
      const data = {
        inner: this.inner
      }
      this.$emit('input', JSON.stringify(data))
      this.$emit('change', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/config/Donut.vue